import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { PlessBlockLayerService } from './pless-block-layer.service';
import { PlessService } from '../pless-service.model';
import { PlessDialogService } from '../pless-dialog-service';
import { PlessViewUtils } from '../utils/pless-view-utils.service';

/** ダウンロード時に使用する ServiceInfo の内容 */
interface ServiceInfo {
  url: string;
  showBusyCursor: boolean;
}

/**
 * ファイルダウンロード機能を適用するサービス
 */
@Injectable()
export class PlessDownloadService {

  constructor(protected http: HttpClient, protected dialogService: PlessDialogService) { }

  protected serviceInfo: ServiceInfo;
  private blockLayerService: PlessBlockLayerService;

  /**
   * リクエスト送信
   *
   * @param id PlessServiceで指定したAPIのID
   * @param body 送信する内容
   * @param fileName 保存時のファイル名
   */
  send(id: string, body: any, fileName: string) {
    this.serviceInfo = PlessService.SERVICE[id];
    this.blockLayerService = new PlessBlockLayerService();
    if (this.serviceInfo.showBusyCursor) {
      this.blockLayerService.createBlockLayer();
    }
    this.executeSend(id, body)
      .then((response) => {
        if (this.serviceInfo.showBusyCursor) {
          this.blockLayerService.removeBlockLayer();
        }
        this.success(response, fileName);
      })
      .catch((error) => {
        if (this.serviceInfo.showBusyCursor) {
          this.blockLayerService.removeBlockLayer();
        }
        this.fault(error);
      });
  }

  /**
   * 送信処理
   *
   * @param id PlessServiceで指定したid
   * @param body 送信する内容
   */
  executeSend(id: string, body: any): Promise<any> {
    const data = 'xmlData=' + body;
    const csrfToken = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='));
    const jwt = document.cookie.split('; ').find(row => row.startsWith('PEACE_JWT='));

    return this.http.post(this.serviceInfo.url, data, {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-XSRF-TOKEN': csrfToken ? csrfToken.split('=')[1] : '',
        Authorization: jwt ? 'Bearer ' + jwt.split('=')[1] : '',
      }),
      responseType: 'blob',
      withCredentials: true
    }).toPromise();
  }

  /**
   * リクエスト成功時のメソッド。
   *
   * @param data dataタグの値
   * @param fileName 保存時のファイル名
   */
  success(response: any, fileName: string) {
    // ファイルに保存する
    this.saveBlob(response, fileName);
  }

  /**
   * リクエスト失敗時のメソッド。
   *
   * @param error エラー内容
   */
  fault(error: any) {
    this.dialogService.openAlert('ダウンロードに失敗しました。', 'S0105');
  }

  /**
   * blobをファイルに保存
   *
   * @param blob 保存するblob
   * @param fileName 保存時のファイル名
   */
  saveBlob(blob: Blob, fileName: string) {
    // IE以外の場合
    const url = window.URL;
    // ダウンロード用のURL作成
    const dataUrl = url.createObjectURL(blob);
    // イベント作成
    const event = document.createEvent('MouseEvents');
    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    // a要素を作成
    const a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    // ダウンロード用のURLセット
    a['href'] = dataUrl;
    // ファイル名セット
    a['download'] = fileName;
    // イベントの発火
    a.dispatchEvent(event);
    // }
  }

  /**
   * XMLのタグ内で使用できない文字をエスケープする
   *
   * @param value エスケープ対象文字列
   */
  protected escapeXML(value: string): string {
    return PlessViewUtils.escapeXML(value);
  }
}
